const dataslayer = {
  data() {
    return {
      dataslayer: null,
    };
  },
  created() {
    const updateMeasurementData = (data) => {
      if (!data?.customData) {
        return;
      }
      this.measurementData = data.customData;
    };
    const push = (event, data) => {
      const customData = data.customData || data;
      window.dataLayer.push({
        event: 'video',
        type: 'content',
        action: event,
        playerType: 'miniplayer',
        data: {
          id: customData.videoID,
          title: customData.video.title,
          target: location.href,
          length: data.duration,
        },
      });
    };

    this.dataslayer = {
      updateMeasurementData,
      push,
    };
  },
};

export default dataslayer;
